var _path, _rect, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.0342,
    y: 22.5202,
    width: 13.5593,
    height: 7.23164,
    fill: "#F78670"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4863,
    y: 29.7515,
    width: 25.3107,
    height: 27.1186,
    fill: "#F78670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9111 25.1896C44.9111 25.7113 45.348 26.1355 45.8853 26.1355H53.0567C52.9816 26.0416 52.911 25.9458 52.8233 25.8598L45.1952 18.4534C45.1065 18.3682 45.0079 18.2997 44.9111 18.2259V25.1896Z",
    fill: "#F78670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3762 27.1738C44.9947 27.1738 43.8713 26.0519 43.8713 24.6721V18H25.5048C24.1187 18 23 19.1258 23 20.5017V55.482C23 56.8579 24.1187 57.9837 25.5048 57.9837L49.8004 58C50.6687 58 51.4866 57.6671 52.1045 57.0492C52.7138 56.4406 53.0565 55.6237 53.0565 54.7565V27.1738H46.3762ZM28.0089 26.3275H34.6877V27.9954H28.0089V26.3275ZM28.0089 31.331H48.046V32.9988H28.0089V31.331ZM28.0089 36.3337H48.046V38.0015H28.0089V36.3337ZM33.0178 53.0112H28.0081V51.3434H33.0178V53.0112ZM36.3576 48.0077H28.0089V46.3399H36.3576V48.0077ZM39.6966 43.005H28.0081V41.3372H39.6966V43.005ZM49.7152 53.2164C49.7152 54.1363 48.9663 54.8842 48.0453 54.8842H42.2014C41.2804 54.8842 40.5315 54.1363 40.5315 53.2164V45.5068C40.5315 44.5869 41.2804 43.8389 42.2014 43.8389H48.0453C48.9663 43.8389 49.7152 44.5869 49.7152 45.5068V53.2164Z",
    fill: "#02475E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocuments);
export default __webpack_public_path__ + "static/media/NoDocuments.760847a59b053a0bc881a575db6f1ec6.svg";
export { ForwardRef as ReactComponent };